import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import "./index.css";
import App from "./app";

// Detect which context we're in based on the URL prefix
const isSupport = window.location.pathname.startsWith("/support");
const basename = isSupport
  ? "/support"
  : (import.meta.env.VITE_BASE_PATH || "/docs");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>
);
